<script>
    import {_, locale} from 'svelte-i18n';
    import {capitalizeFirstLetter} from '../../utils';
    import Item from './Item.svelte';
    import {gameConfig} from "../../stores.js";

    let { item, gameItem, fallbackExpireAt = undefined } = $props();
    let itemDetails = $state({});

    function getTokenDetails() {
        let details = {};

        let tokenType = gameItem.type ? gameItem.type : '';
        let tokenRarity = gameItem.tokenRarity ? gameItem.tokenRarity : '';

        let eventTheme = gameItem.event ? gameItem.event : 'generic';

        if (eventTheme === 'fathersday') {
            eventTheme = 'fathersDay';
        }

        let eventThemeTranslation = eventTheme === 'stPatrick' ? eventTheme : capitalizeFirstLetter(eventTheme);

        details.icon = gameItem.category.toLowerCase() + '_' + tokenType.toLowerCase() + (tokenRarity !== '' ? '_' + tokenRarity.toLowerCase() : '') + '_' + eventTheme.toLowerCase();
        details.title = $_(
            capitalizeFirstLetter(gameItem.category) +
            capitalizeFirstLetter(tokenType) +
            capitalizeFirstLetter(tokenRarity) +
            eventThemeTranslation +
            'Title',
        );
        details.description = $_(
            capitalizeFirstLetter(gameItem.category) +
            capitalizeFirstLetter(tokenType) +
            capitalizeFirstLetter(tokenRarity) +
            eventThemeTranslation +
            'Description',
        );

        return details;
    }

    function setItemDetails() {
        const tokenDetails = getTokenDetails();
        // The webshop get-config doesn't carry the pvpArena event's expiry in
        // temporaryItems, so for temporary tokens fall back to the pack's endAt
        // (set to the event's finishAt by the smart-pack trigger).
        const expireAt = $gameConfig?.temporaryItems?.[item.id]
            ?? (gameItem.temporary ? fallbackExpireAt : undefined);

        itemDetails.title = tokenDetails.title;
        // Temporary tokens (e.g. event grind tokens) expire when the event ends —
        // surface that in the description instead of the generic token blurb.
        itemDetails.description = expireAt
            ? `${tokenDetails.title} (${$_('Temporary', { default: 'Temporary' })})`
            : tokenDetails.description;
        itemDetails.icon = tokenDetails.icon;
        itemDetails.amount = item.amount;
        itemDetails.rarity = gameItem.rarity ? gameItem.rarity : 1;
        itemDetails.expireAt = expireAt;
        itemDetails.claimed = item.claimed;
    }

    $effect(() => {
        $locale;
        setItemDetails();
    });
</script>

<Item {itemDetails}/>
